<template>
	<div id="app" v-if="$route.name">
		<app-header></app-header>
		<div
			v-if="$te($route.name + '.coverTitle', 'en-CA')"
			class="cover"
			:class="{ 'cover--small': $route.name != 'home' }"
			:style="'background-image: url(' + require('@/assets/cover/' + $route.name + '.jpg') + ')'">
			<div class="cover__info">
				<section class="section-wrapper section-wrapper--large">
					<h1 class="title" v-if="$te($route.name + '.coverTitle', 'en-CA')" v-html="$t($route.name + '.coverTitle')"></h1>
					<p class="text" v-if="$te($route.name + '.coverSubtitle', 'en-CA')" v-html="$t($route.name + '.coverSubtitle')"></p>
					<div v-if="$route.name == 'home'" class="l-grid l-display--inline-flex l-g-10 l-display--home-hero">
						<div class="l-grid__col l-grid__col--home-hero"><router-link class="button button--large button--arrow button--grey" :to="$locale.toRouteLinkProp('crm')">Prospects CRM</router-link></div>
						<div class="l-grid__col l-grid__col--home-hero"><router-link class="button button--large button--arrow" :to="$locale.toRouteLinkProp('mobile')">{{ $t("mobileName") }}</router-link></div>
					</div>
				</section>
			</div>
		</div>
		<router-view></router-view>
		<app-footer></app-footer>
		<div class="modal" v-if="$store.state.modal && $store.state.modal.opened">
			<div class="modal__content" :is="$store.state.modal.component" v-on-clickaway="closeModal"></div>
		</div>
	</div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { mixin as clickaway } from 'vue-clickaway';

export default {
	components: { AppHeader, AppFooter },
	mixins: [ clickaway ],
	created () {
		this.addGoogleAnalytics();
	},

	mounted () {
		gtag('js', new Date());
		gtag('config', 'G-WW4GE0F9DV', {
			'send_page_view': false
		});
	},

	data () {
		return {

		}
	},

	computed: {

	},

	methods: {
		addGoogleAnalytics () {
			(function() { 
				var script = document.createElement('script');
				script.async = true;
				script.src = 'https://www.googletagmanager.com/gtag/js?id=G-WW4GE0F9DV';
				document.querySelector('head').appendChild(script);
				window.dataLayer = window.dataLayer || [];
				window.gtag = function (){dataLayer.push(arguments);}
			})();
		},
		closeModal () {
			this.$store.commit('closeModal');
		}
	}
};
</script>

<style lang="scss">
	@import './css/reset.scss';
	@import './css/grid.scss';
	@import './css/font/prospects.css';
	@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700');

	body { font: 1.8em/1 'Montserrat', sans-serif; color: black; }
	.page-wrapper { width: 92%; max-width: 1280px; margin: 0 auto; }


	#video_player { display: none; position: fixed; z-index:9999; margin: auto; left: 0;right: 0; top: 0; bottom: 0; justify-content: center; align-items: center; }
	#video_player::before { content: " "; z-index:-1; position: fixed; top:0; bottom:0; left:0; right:0; background: rgba(0,0,0,0.7); }
	#video_player.video_player--open { display: flex; }

	.u-weight-light { font-weight: 300!important; }
	.u-weight-normal { font-weight: 400!important; }
	.u-weight-semibold { font-weight: 500!important; }
	.u-weight-bold { font-weight: 600!important; }
	.u-weight-bolder { font-weight: 700!important; }
	.u-underline { text-decoration: underline; }
	.u-color-red { color: #c51b1e!important; }

	.title { font-size: 4rem; font-weight: 500; color: #333333;  }
	.title--icon { display: inline-flex; align-items: flex-end; }
	.title--icon [class*="icon-"] { font-size: 5rem; }
	.title--medium { font-size: 2rem; }
	.title--medium [class*="icon-"] { font-size: 5rem; }
	.title--white { color: white; }
	.title--bold { font-weight: bold; }
	.title--botMargin { margin-bottom: 20px; }
	.subtitle { font-size: 1.9rem; line-height: 1.5; }
	.text { line-height: 1.5; }
	.text--white { color: white; }
	.text--botMargin { margin-bottom: 20px;}
	.link { color: #c71418; }
	.link--white { color: white; }
	.link:hover { cursor: pointer; text-decoration: underline; }
	.link--arrow::before { content: "» "; }

	select { position: relative; border:1px solid #d7d7d7; outline: none; height: 45px; padding: 5px 15px; margin-left: 0; margin-bottom: 0; border-radius: 5px; width: 100%; appearance: none; background: url("./assets/dropdown_arrow.svg") white no-repeat right;}
	select:hover { cursor: pointer; background-color: #fafafa; border:1px solid #d7d7d7; }
	select:focus { border: 1px solid #d7d7d7; }

	.separator { padding-left: 50px; padding-right: 50px; padding-top: 60px; padding-bottom: 60px; }
	.separator--background { background: #f9f9f9; }
	.separator--gradient { background: linear-gradient(white, #f9f9f9); }
	.separator:not(.separator--background):not(.separator--gradient) + .separator:not(.separator--background) { padding-top: 0; }

	.infobox { background: #f9f9f9; display: flex; min-height: 400px; }
	.infobox__col { flex: 1; position: relative; overflow: hidden; }
	.infobox__col:first-child { padding: 70px 70px; }
	.infobox__image { position: absolute; min-width: 100%; height: 100%; top: -9999px; bottom: -9999px; left: -9999px; right: -9999px;margin: auto; }
	.infobox__imgOverlay {
		font-size: 1.8rem;
		flex-direction: column;
		justify-content: flex-end;
		text-align: right;
		display: flex;
		&:before {
			content: ' ';
			border-top: 1px solid #e11e1f;
			padding: 10px 0;
			width: 70px;
			align-self: flex-end;
		}
		@include media-breakpoint-up(lg) {
			padding: 10px;
			display: flex;

		}
		@include media-breakpoint-up(xl) {
			display: flex;
			
		}
	}
	.imgOverlay__name {
		font-weight: 500;
		margin-bottom: 10px;
	}
	.imgOverlay__title {}

	.section-wrapper { width: 100%; max-width: 600px; margin-left:auto; margin-right: auto; }
	.section-wrapper--small { max-width: 400px; }
	.section-wrapper--large { max-width: 875px; }
	.section-wrapper--infinite { max-width: none; }
	.section-wrapper .title,
	.section-wrapper .subtitle,
	.section-wrapper .text { margin-bottom: 20px; }

	.button { display: inline-block; white-space: nowrap; box-sizing: border-box; padding: 10px 40px; border-radius: 5px; background: #c51b1e; color: white; text-transform: uppercase; transition: opacity 0.35s; appearance: none; border: 0; outline:none; }
	.button--grey { background: #999999; }
	.button:hover { opacity: 0.7; color: white; cursor: pointer; }
	.button--secondary { padding: 9px 40px; border-radius: 5px; background: transparent; color: #c51b1e; font-weight: 600; border: 2px solid #c51b1e; }
	.button--secondary:hover { border-color: #c03736; color: #c03736; }
	.button--secondary-black { border-color: black; color: black; }
	.button--arrow { font-weight: 500; }
	.button--arrow::after { content: ">"; padding-left: 10px; font-family: monospace, courier; font-size: 1.3em; }
	.button--small { padding: 5px 30px; }
	.button--large { padding: 15px 40px; }
	.button--redFade {
		transition: background 0.35s;
		&:hover {
			background: #c03736;
			opacity: 1;
		}
	}

	.menu { display: flex; align-items: center; list-style: none; color: black; }
	.menu--white { color: white; }
	.menu--vertical { flex-direction: column; align-items: flex-start; }
	.menu__item { margin-left: 30px; position: relative; }
	.menu--vertical .menu__item { margin-left:0; margin-top: 15px; }
	.menu__item:first-child { margin-left: 0; }
	.menu--vertical .menu__item:first-child { margin-top:0; }
	.menu__link:hover { color: #c51b1e; }

	.scroll-bullet { content: " "; background: url('./assets/down-button.svg') no-repeat; width: 65px; height: 65px; position: absolute; bottom: -32.5px; left:0; right:0; margin: auto; cursor: pointer; z-index:10; }

	.cover { width: 100%; height: 1000px; max-height: calc(85vh - 75px); display: flex; justify-content: flex-end; align-items: center; position: relative; background-repeat: no-repeat; background-size: auto 100%; background-position: right 45vw center; }
	.cover__info { width: 45%; padding: 0px 7.5% 0 3%; box-sizing: border-box; }
	.cover:not(.cover--small) .title { font-size: 6rem; line-height: 1; }
	.cover:not(.cover--small) .text { font-size: 1.8rem; }
	.cover--small { max-height: 350px; background-size: cover; background-position: center; }
	.cover--small .cover__scroll { display: none; }
	.cover--small .cover__image, .cover--small .cover__info { flex-basis: 100%; text-align: center; color: white; }
	.cover--small .cover__image { width: 100%; height: auto; left: 0; right: 0; z-index: 0; }
	.cover--small::after { left: 0; right:0; width: 100%; }
	.cover--small .title { color: white; }
	.cover--small .cover__info { padding: 0px 3%;}
	.l-display--home-hero {
		flex-direction: column;
		@include media-breakpoint-up(lg) {
			flex-direction: row;
		}
	}
	.l-grid__col--home-hero {
		flex-basis: auto;
		@include media-breakpoint-up(lg) {
			flex-basis: 0;
		}
	}

	.jumbotron { min-height: 400px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; position: relative; }
	.jumbotron--image { background-size: cover; background-repeat: no-repeat; background-position: center; }
	.jumbotron__ribbon { width: 500px; background: #d12728; position: absolute; top: 0; bottom: 0; right: 15%; display: flex; flex-direction: column; justify-content: center; padding: 0 50px; box-sizing: border-box; text-align: left; }

	.citation { font-style: italic; }
	.citation__author, .citation__title { display: block; font-style: normal; }
	.citation__author { margin-top: 20px; font-size: 2.3rem; }
	.citation__title { font-weight: bold; }

	.table { overflow-x: auto; }
	.table__wrapper { width: 100%; border:none; border-spacing:0; text-align: center; }
	.table__head { text-decoration: underline; padding-bottom: 30px; text-transform: uppercase; color: #333333; }
	.table__row:nth-child(even) .table__cell { background: #f5f6fa;  }
	.table__cell { padding: 10px 15px; background: white; }
	
	.modal { content:' '; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.9); position: fixed; top: 0; left: 0; z-index: 999999;;}
	.modal__content { width: 75%; height: 80%; background: #fff; z-index: 999999; position: fixed; top: 0; left: 0; right: 0; bottom: 0; margin: auto;}
	

	.contact-form { border-top: 2px solid #f7f7f7;  position: relative; }
	.contact-form::after { content: " "; position: absolute; width: 100%; top:0; bottom:0; right:0; }
	.contact-form__wrapper { display: flex; flex-wrap: wrap; position:relative; z-index:1; }
	.contact-form__form { width: 50%; }
	.contact-form__info { margin-left: 40px; flex:1; }
	.contact-form__address { font-style: normal; }
	.contact-form__address h2 { color: #cc0000; font-weight: 600; text-decoration: underline; margin:0; margin-top: 20px; font-size: 2rem; }
	.contact-form__address p { margin: 5px 0; }
	.contact-form__success { display: none; border: 1px solid #8fbe32; padding: 15px 15px; background: #8fbe32; border-radius: 10px; color: white; }
	.contact-form__success--visible { display: block; }

	.form__label, .form__input, .form__textarea { width: 100%; display: block; }
	.form__input, .form__textarea { margin-top: 4px; padding: 10px 5px; border: 1px solid #c7c7c9; border-radius: 3px; outline: none; box-sizing: border-box; }
	.form__input:focus, .form__textarea:focus { border: 1px solid #d02627; }
	.form__textarea { height: 100px; }

	.contact-form label { margin-top: 20px; }
	.contact-form textarea { margin-bottom: 20px; }

	@media (max-width: 1100px) {
		.cover:not(.cover--small) { background-image: url('./assets/cover/home-mobile.jpg')!important; background-position: 40%; height: auto; padding: 70px 0; }
		.cover__info { width: 90%; padding: 0px 10% 0 5%; margin: auto; }
		.cover:not(.cover--small) .title { font-size: 4rem; }
		.cover:not(.cover--small) .text { font-size: 1.8rem; }
	}

	@media (max-width: 900px) {
		.separator { padding: 60px 30px; }
		.separator--mobile { padding: 20px 0; }
		.separator.page-wrapper, .separator .page-wrapper { width: auto; }
		.infobox { overflow: hidden; }
		.infobox__col { overflow: visible; text-align: center; }
		.infobox__col:first-child { z-index: 2; padding: 70px 20px; flex-basis: 100%; }
		.infobox__col:last-child { width: 0; right: 50%; }
		.infobox__image { opacity: 0.1; filter: blur(5px); }
		.jumbotron { padding: 0 20px; overflow: hidden; }
		.jumbotron--ribbon { background-position-y: 0; background-position-x: 15%; background-size: auto 50%; padding: 0; }
		.jumbotron__ribbon { margin-top: 75%; position: relative; width: 100%; right: 0; left: 0; padding: 30px; }
		.jumbotron .title { font-size: 3rem; }
	}

	@media (max-width: 700px) {
		.cover:not(.cover--small) { background-position: 68%; padding: 100px 0; }
		.cover .button { width: 100%; text-align:center; }
		.cover__info { padding: 0px 15% 0 5%; width: 100%; }
		.modal__content { width: 100%; height: auto;}
	}
	
</style>
